<template>
  <div v-if="saasSearchServiceList">
    <div class="serviceList">
      <div
        class="serviceItem"
        :class=" serviceLevel == serviceItem.serviceLevel ?  'serviceItem-active serviceItem-'+serviceItem.serviceLevel : 'serviceItem-'+serviceItem.serviceLevel"
        :style="serviceItem.serviceLevel == 1? 'cursor:not-allowed':''"
        v-for="serviceItem in saasSearchServiceList.service"
        @click="changeServiceLevel(serviceItem.serviceLevel)"
      >
        <div class="service-checkbox" v-if="serviceLevel == serviceItem.serviceLevel">
          <div class="service-checkbox-bg"></div>
          <span class="service-checkbox-icon"></span>
        </div>

        <div class="serviceVersion">{{serviceItem.serviceName}}</div>
        <div v-if="showPrice">
          <div
            class="servide-price"
            v-if="saasSearchServicePrice && saasSearchServicePrice.cashAmount[serviceItem.serviceLevel]"
          >
            <span
              class="servide-price-number"
            >{{saasSearchServicePrice.cashAmount[serviceItem.serviceLevel]}}</span> 元/年
          </div>
          <div
            class="servide-price"
            v-if="saasSearchServicePrice && !saasSearchServicePrice.cashAmount[serviceItem.serviceLevel]"
          >
            <span class="servide-price-number">免费</span>
          </div>
        </div>
        <div class="funs-list" v-for="funcItem in serviceItem.funcList">
          <div class="funs-item-name">{{funcItem.name}}</div>
          <ul>
            <li :class="{'acitve':subItem.status}" v-for="subItem in funcItem.list">{{subItem.name}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      serviceLevel: 2
    };
  },
  props: {
    unitLevel: Number,
    showPrice: Boolean
  },
  computed: {
    ...mapGetters({
      saasSearchServiceList: "saasSearchServiceList",
      saasSearchServicePrice: "saasSearchServicePrice"
    }),
    servicePriceParams() {
      let serviceLevelList = [];
      this.saasSearchServiceList.service.forEach(item => {
        serviceLevelList.push({
          unitLevel: this.unitLevel,
          serviceLevel: item.serviceLevel,
          month: 12
        });
      });
      return serviceLevelList;
    },
    totalCost() {
      let result = null;
      if (this.saasSearchServicePrice) {
        result = this.saasSearchServicePrice.cashAmount[this.serviceLevel];
      }
      return result;
    }
  },
  methods: {
    changeServiceLevel(val) {
      if (val == 1) return;
      this.serviceLevel = val;
    },
    getSaasSearchServicePrice() {
      this.$store.dispatch("saasSearchServicePrice", this.servicePriceParams);
    },
    getTotalCost() {
      return this.totalCost;
    }
  },
  watch: {
    unitLevel(cVal) {
      if (cVal) {
        this.getSaasSearchServicePrice();
      }
    },
    saasSearchServiceList(cVal) {
      if (!cVal) return;
      this.getSaasSearchServicePrice();
    }
  },
  created() {
    this.$store.dispatch("saasSearchServiceList");
  }
};
</script>
<style lang="less" scoped>
.fL {
  float: left;
}
.fR {
  float: right;
}
.clear {
  clear: both;
}
.hide {
  display: none;
}

.serviceItem {
  border: none;
  padding: 4px;
  float: left;
  margin-right: 16px;
  position: relative;
  width: 304px;
  height: 672px;
  box-shadow: 0px 9px 13px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;

  .service-checkbox {
    .service-checkbox-bg {
      transform: rotate(45deg);
      bottom: -28px;
      right: -28px;
      position: absolute;
      width: 56px;
      height: 56px;
      background: rgba(115, 217, 250, 1);
    }

    .service-checkbox-icon {
      bottom: 0;
      right: 0;
      position: absolute;
      width: 25px;
      height: 20px;
      background-image: url("../../assets/img/icon.png");
    }
  }

  .serviceVersion {
    height: 74px;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    color: rgba(89, 210, 249, 1);
    line-height: 74px;
  }

  .servide-price {
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    width: 256px;
    border-bottom: solid 1px rgba(215, 221, 224, 1);
    margin: 0 auto;
    .servide-price-number {
      width: 82px;
      height: 27px;
      font-size: 38px;
      font-family: Helvetica;
      font-weight: bold;
      color: rgba(102, 102, 102, 1);
    }
  }

  .funs-list {
    padding-top: 10px;
    padding-left: 25px;
    .funs-item-name {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 29px;
    }
    li {
      background: url("../../assets/img/icon16.png") 0 8px no-repeat;
      font-size: 14px;
      font-weight: 400;
      color: #7F7F7F;
      line-height: 26px;
      padding-left: 20px;
    }
    li.acitve {
      background-image: url("../../assets/img/icon15.png");
      background-position: 0 7px;
      color: #333333;
    }
  }
}

.serviceItem-1 {
  background: rgba(255, 255, 255, 1);
}

.serviceItem-2 {
  background: white url("../../assets/img/icon12.png") no-repeat;
  .serviceVersion {
    color: white;
  }
}

.serviceItem-3 {
  background: white url("../../assets/img/icon13.png") no-repeat;
  .serviceVersion {
    color: white;
  }
  &.serviceItem-active {
    border-color: #b87e4a;
  }
  .service-checkbox {
    .service-checkbox-bg {
      background-color: #b87e4a;
    }
  }
}

.serviceItem-active {
  padding: 0px;
  border: 4px solid rgba(115, 217, 250, 1);
  background-position-x: -4px;
  background-position-y: -4px;
}

.serviceItem:last-child {
  margin-right: 0;
}
</style>